import React from 'react';
import AppActionMenu from '../../../../components/AppActionMenu';

export default function LeaveBalanceTable({
  records = [],
  isLoading = false,
  onApplyLeave,
  onResetFilters,
}) {
  if (isLoading) {
    return (
      <div className="flex h-64 w-full items-center justify-center rounded-xl border border-outline-variant/20 bg-surface-container-lowest">
        <div className="flex flex-col items-center gap-2">
          <div className="h-8 w-8 animate-spin rounded-full border-3 border-primary border-t-transparent" />
          <span className="text-xs font-semibold text-on-surface-variant">Loading leave balances...</span>
        </div>
      </div>
    );
  }

  if (records.length === 0) {
    return (
      <div className="flex h-64 w-full flex-col items-center justify-center rounded-xl border border-outline-variant/20 bg-surface-container-lowest p-8 text-center">
        <span className="material-symbols-outlined mb-2 text-4xl text-outline-variant">
          account_balance_wallet
        </span>
        <h3 className="font-display text-sm font-bold text-black">No Leave Balance Records Found</h3>
        <p className="mt-1 text-xs text-slate-600 max-w-sm">
          No balance entries matched your selected filter criteria.
        </p>
        {onResetFilters && (
          <button
            type="button"
            onClick={onResetFilters}
            className="mt-4 inline-flex items-center gap-1.5 rounded-xl bg-primary/10 px-3.5 py-1.5 text-xs font-bold text-primary hover:bg-primary/20 transition cursor-pointer"
          >
            <span className="material-symbols-outlined text-sm">refresh</span>
            <span>Reset Filters</span>
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-xl border border-outline-variant/25 bg-surface-container-lowest shadow-xs">
      <div className="overflow-x-auto">
        <table className="w-full text-left text-sm border-collapse">
          <thead>
            <tr className="border-b border-outline-variant/25 bg-surface-container-low/40 text-[11px] font-extrabold uppercase tracking-wider text-black">
              <th className="py-3.5 px-6 text-black">NAME</th>
              <th className="py-3.5 px-6 text-black">LEAVE TYPE</th>
              <th className="py-3.5 px-6 text-right text-black">OPENING</th>
              <th className="py-3.5 px-6 text-right text-black">CONSUME</th>
              <th className="py-3.5 px-6 text-right text-black">LAPS</th>
              <th className="py-3.5 px-6 text-right text-black">CURRENT</th>
              <th className="py-3.5 px-6 text-right w-20 text-black">ACTIONS</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-outline-variant/15">
            {records.map((record, index) => {
              return (
                <tr
                  key={record.id || index}
                  className="transition-colors hover:bg-surface-container-low/50 group"
                >
                  {/* NAME */}
                  <td className="py-4 px-6 whitespace-nowrap">
                    <div className="flex items-center">
                      <span className="font-bold text-sm text-black font-sans not-italic">
                        {record.name || 'Divyanshu Singh'}
                      </span>
                      {record.empId && (
                        <span className="text-xs text-slate-600 font-sans tabular-nums not-italic font-semibold ml-1.5">
                          ({record.empId})
                        </span>
                      )}
                    </div>
                  </td>

                  {/* LEAVE TYPE */}
                  <td className="py-4 px-6 font-bold text-sm text-black font-sans not-italic whitespace-nowrap">
                    <div className="flex items-center gap-2">
                      <span>{record.leaveType}</span>
                      {record.encashable && (
                        <span className="rounded-md bg-blue-50 px-1.5 py-0.5 text-[10px] font-bold text-blue-700 border border-blue-200">
                          Encashable
                        </span>
                      )}
                    </div>
                  </td>

                  {/* OPENING */}
                  <td className="py-4 px-6 text-right font-bold text-sm text-on-surface font-sans tabular-nums whitespace-nowrap">
                    {record.opening}
                  </td>

                  {/* CONSUME */}
                  <td className="py-4 px-6 text-right font-semibold text-sm text-slate-700 font-sans tabular-nums whitespace-nowrap">
                    {record.consume}
                  </td>

                  {/* LAPS */}
                  <td className="py-4 px-6 text-right font-medium text-sm text-slate-500 font-sans tabular-nums whitespace-nowrap">
                    {record.laps}
                  </td>

                  {/* CURRENT / AVAILABLE */}
                  <td className="py-4 px-6 text-right whitespace-nowrap">
                    <span className="inline-block rounded-full bg-emerald-500/10 px-3 py-0.5 text-xs font-bold text-emerald-600 font-sans tabular-nums">
                      {record.current}
                    </span>
                  </td>

                  {/* ACTIONS */}
                  <td className="py-4 px-6 text-right whitespace-nowrap">
                    <div className="flex items-center justify-end">
                      <AppActionMenu
                        triggerLabel=""
                        triggerIcon="more_vert"
                        showChevron={false}
                        triggerClassName="rounded-lg p-1 text-[#4b5563] hover:text-black hover:bg-surface-container-high transition bg-transparent cursor-pointer"
                        items={[
                          {
                            key: 'apply',
                            label: 'Apply for Leave',
                            icon: 'add_circle',
                            onClick: () => onApplyLeave?.(record.leaveType),
                          },
                          {
                            key: 'print',
                            label: 'Print Ledger',
                            icon: 'print',
                            onClick: () => window.print(),
                          },
                        ]}
                        onSelect={(key) => {
                          if (key === 'apply') onApplyLeave?.(record.leaveType);
                          if (key === 'print') window.print();
                        }}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
